<template>
  <div id="shopifyAuthPage" class="flex-col justify-center items-center min-h-screen bg-white flex">
    <!-- Authenticating -->
    <div v-if="isLoading" class="flex flex-col justify-center items-center h-1/2 w-1/2">
      <div class="pt-10">
        <img style="height: 100px; margin-bottom: 50px" src="@/assets/images/logo-full.png" />
      </div>
      <i class="mt-10 fa-sharp-duotone fa-solid fa-spinner-third fa-spin text-black-600 text-xl" style="font-size: 80px; margin-bottom: 50px; --fa-animation-duration: 2s"></i>
      <div class="pt-10 text-center text-primary-600" style="margin-bottom: 50px">Verifying Shopify Access</div>
    </div>

    <!-- Company Creation In Progress -->
    <div v-else-if="setupInProgress" class="flex flex-col justify-center items-center h-1/2 w-1/2">
      <div class="pt-10">
        <img style="height: 100px; margin-bottom: 50px" src="@/assets/images/logo-full.png" />
      </div>
      <i class="mt-10 fa-sharp-duotone fa-solid fa-spinner-third fa-spin text-primary-600 text-xl" style="font-size: 100px; margin-bottom: 50px; --fa-animation-duration: 2s"></i>
      <div class="pt-10 text-center text-primary-600" style="margin-bottom: 50px">
        Setting up your account, this may take one or two minutes. <br />
        Please do not refresh the browser.
      </div>
    </div>
  </div>
</template>

<script>
import ShopifyAuthComponent from './shopifyAuthComponent';
export default ShopifyAuthComponent;
</script>

<style lang="scss" src="./shopifyAuth.scss"></style>
